import type { TranscriptEntry } from "../types";

interface Props {
  transcripts: TranscriptEntry[];
  filter: "pending" | "completed";
  selectedId: string | null;
  onFilterChange: (f: "pending" | "completed") => void;
  onSelect: (fileId: string) => void;
}

export default function TranscriptList({ transcripts, filter, selectedId, onFilterChange, onSelect }: Props) {
  const visible = transcripts.filter((t) =>
    filter === "completed" ? t.state === "completed" : t.state !== "completed"
  );

  return (
    <div style={containerStyle}>
      <div style={filterBarStyle}>
        {(["pending", "completed"] as const).map((f) => (
          <button
            key={f}
            onClick={() => onFilterChange(f)}
            style={filterBtnStyle(filter === f)}
          >
            {f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>

      <div style={{ flex: 1, overflowY: "auto" }}>
        {visible.length === 0 && (
          <div style={{ padding: "16px 12px", color: "#999", fontSize: 13 }}>
            No {filter} transcripts
          </div>
        )}
        {visible.map((t) => (
          <div
            key={t.fileId}
            onClick={() => onSelect(t.fileId)}
            style={itemStyle(t.fileId === selectedId)}
          >
            <span style={{ flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {t.fileId.split("__").pop()}
            </span>
            {t.state === "draft" && <span title="Draft" style={{ fontSize: 14 }}>📝</span>}
          </div>
        ))}
      </div>
    </div>
  );
}

const containerStyle: React.CSSProperties = {
  width: 240,
  flexShrink: 0,
  borderRight: "1px solid #e0e0e0",
  display: "flex",
  flexDirection: "column",
  background: "#fafafa",
};

const filterBarStyle: React.CSSProperties = {
  display: "flex",
  gap: 6,
  padding: "10px 10px 8px",
  borderBottom: "1px solid #e0e0e0",
  flexShrink: 0,
};

function filterBtnStyle(active: boolean): React.CSSProperties {
  return {
    flex: 1,
    padding: "5px 8px",
    fontSize: 12,
    fontWeight: active ? 600 : 400,
    background: active ? "#333" : "#f0f0f0",
    color: active ? "#fff" : "#444",
    border: "1px solid #ccc",
    borderRadius: 4,
    cursor: "pointer",
  };
}

function itemStyle(selected: boolean): React.CSSProperties {
  return {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "9px 12px",
    fontSize: 13,
    cursor: "pointer",
    background: selected ? "#e8f0fe" : "transparent",
    borderLeft: selected ? "3px solid #4a6cf7" : "3px solid transparent",
    borderBottom: "1px solid #eee",
  };
}
